import React, { PureComponent } from "react";
import {string, number, oneOfType, func, array} from "prop-types";

class NavigationSelect extends PureComponent{
    constructor() {
        super();

        this.normalizeOptions = this.normalizeOptions.bind(this);
    }

    normalizeOptions() {
        return this.props.options.map(option => {
            if (typeof option == "string" || typeof option == "number") {
                return {
                    label: option,
                    value: option
                };
            }

            return option;
        });
    }

    render(){
        return(
            <div className="select-style">
                <select value={this.props.selectedOption} onChange={(e)=>{
                    this.props.changeSelectedOption(e.target.value);
                }}>
                    {
                        this.normalizeOptions().map((option)=>{
                            return <option key={option.value} value={option.value}>{option.label}</option>;
                        })
                    }
                </select>
            </div>
        );
    }
}

NavigationSelect.propTypes = {
    options: array.isRequired,
    selectedOption: oneOfType([
        string,
        number
    ]),
    changeSelectedOption: func
};

export default NavigationSelect;
